<template>
  <v-app fluid>
    <Navigation v-show="isLoggedIn" />
    <v-content :class="{ login: !isLoggedIn, loggedIn: isLoggedIn }">
      <v-container class="pa-0">
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
const Navigation = () => import("./components/Navigation/Navigation");
import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    Navigation,
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.user.isLoggedIn,
    }),
  },
};
</script>
<style lang="scss">
::-webkit-scrollbar {
  display: none;
}
#nav {
  z-index: 2000 !important;
  background: red;
}
#red {
  background: #000;
}

.login {
  padding: 0;
  background: #fff;
}
.loggedIn {
  background: #fafafa;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus input:-webkit-autofill,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  box-shadow: 0 0 0px 1000px #fff inset;
  -webkit-box-shadow: 0 0 0px 1000px #fff inset;
}
</style>
